/* unplugin-vue-components disabled */import script from "./selectEntertainDailog.vue?vue&type=script&setup=true&lang=js"
export * from "./selectEntertainDailog.vue?vue&type=script&setup=true&lang=js"

import "./selectEntertainDailog.vue?vue&type=style&index=0&id=6c517da8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c517da8"]])

export default __exports__